enum SelectSurveyScreen {
    LOADING = '@@selectSurveyScreen/LOADING',
    ERROR = '@@selectSurveyScreen/ERROR',
    SELECT_SURVEY = '@@selectSurveyScreen/SELECT_SURVEY',
    CHANGE_SURVEY_INFO = '@@selectSurveyScreen/CHANGE_SURVEY_INFO',
}

export default SelectSurveyScreen;
